import {firebase} from "../../firebase";

export function getFirebaseCurrentUser(): Promise<firebase.User | null> {
    return new Promise((resolve) => {
        firebase.auth().onAuthStateChanged(async function(user) {
            resolve(user)
        });
    })
}